<template>
  <div class="row">
    <div class="col-6">
      <div class="row">
        <div class="col-6">
          <statistic-counter
            :counter="registeredUsers"
            background="bg-warning"
            title="Utenti Registrati"
            icon="fa fa-user-plus"
          ></statistic-counter>
        </div>
        <div class="col-6">
          <statistic-counter
            :counter="onlineUsers"
            background="bg-success"
            title="Utenti Online"
            icon="fa fa-users"
          ></statistic-counter>
        </div>
      </div>
    </div>
    <div class="col-6">
      <admin-chat :event-id="eventId" :base-url="baseUrl"></admin-chat>
    </div>
  </div>
</template>

<script>
  import axios from "axios";

  export default {
    name: "EventDashboard",
    data() {
      return {
        registeredUsers: "-",
        onlineUsers: "-"
      }
    },
    props: {
      eventId: String,
      baseUrl: String,
    },
    mounted() {
      this.updateData();
    },
    methods: {
      updateData() {
        axios.get(`${this.baseUrl}/statistics`)
          .then(function (response) {
            this.registeredUsers = response.data.registered_users.toString();
            this.onlineUsers = response.data.online_users.toString()

            setTimeout(this.updateData.bind(this), 10000)
          }.bind(this))
      }
    }
  }
</script>

<style scoped>

</style>
